export default {
    init() {
      // JavaScript to be fired on the home page

		// Cache element
		var $root = $('html, body');

		// Scroll animato ancora
		$('.faq-single-link a[href*="#"]').click(function(event) {
			event.preventDefault();
			let target = $(this.hash);
			let offsetAdjust = $('header').height() + 30;
			$root.animate({
				scrollTop: target.offset().top - offsetAdjust,
			}, 800);
		});
    },
    finalize() {
      // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/faq.js